import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import '../types/shared/products.js';
import { useTealiumEventProperties } from '../events/event-properties-provider.js';
import '../events/use-track-error-event.js';
import { useTrackPageView } from '../events/use-track-page-view.js';

const useTrackErrorPageView = ({ statusCode  })=>{
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const errorPageView = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        return Promise.resolve(swcHelpers.objectSpread({}, commonEventProperties, commonUserProperties, {
            id: 'VirtualPage-View',
            Page_Type: 'Error',
            Page_Section1: 'Other',
            Page_Section2: `ErrorHttp${statusCode}`
        }));
    }), // Only need to trigger this page view on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getCommonUserProperties
    ]);
    useTrackPageView(errorPageView);
};

export { useTrackErrorPageView };
//# sourceMappingURL=use-track-error-page-view.js.map
